import { render } from "./TrayFull.vue?vue&type=template&id=1853b9e1"
import script from "./TrayFull.vue?vue&type=script&lang=js"
export * from "./TrayFull.vue?vue&type=script&lang=js"

import exportComponent from "../../vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"@apostrophecms/vue-material-design-icons/TrayFull.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "1853b9e1"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('1853b9e1', __exports__)) {
    api.reload('1853b9e1', __exports__)
  }
  
  module.hot.accept("./TrayFull.vue?vue&type=template&id=1853b9e1", () => {
    api.rerender('1853b9e1', render)
  })

}


export default __exports__